import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from 'tss-react/mui';
import Form from 'src/app/common/components/Form';
import { KeyTaskConfiguration } from '../../../../types/key-task-summarizer-type';
import { ConfigurationRules } from '../keyTaskSummarizerDetailForm.rules';
import { CampaignSelect } from '../CampaignSelect/campaign-select';
import { CampaignItem } from 'src/app/modules/PruleadInsightsReporting/types/insights-types';

const useStyles = makeStyles()((theme) => ({
  campaignField: {
    marginTop: theme.spacing(1),
  },
}));

type CustomerOfferFieldsProps = {
  isDisabled: boolean;
  campaign: KeyTaskConfiguration['selectedCampaign'];
  configurationRules: (field: keyof KeyTaskConfiguration) => ConfigurationRules;
  onChangeFields: (fields: Partial<KeyTaskConfiguration>) => void;
};

const CustomerOfferFields: FC<CustomerOfferFieldsProps> = ({
  isDisabled,
  campaign,
  configurationRules,
  onChangeFields,
}) => {
  const { classes } = useStyles();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  const onCampaignChange = (campaign: CampaignItem | null) => {
    onChangeFields({ selectedCampaign: campaign });
  };

  return (
    <div className={classes.campaignField}>
      <Form.Item
        name="selectedCampaign"
        label={Translation('KeyTaskSummerizer.campaign')}
        rules={configurationRules('selectedCampaign')}
      >
        <CampaignSelect
          onRowSelected={onCampaignChange}
          onChange={onCampaignChange}
          selectedId={campaign?._id || ''}
          isView={isDisabled}
        />
      </Form.Item>
    </div>
  );
};

export default CustomerOfferFields;
